import { PopupApiDto } from '@b2x/storefront-api-js-client/src/dto';

import { PopupBuilderCouponDetailsContentSection, PopupContentTypeV2 } from '../contentTypes';
import { P } from '../HTMLElement';
import { t } from '../i18n/i18n';
import { formatHtml } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderCouponDetailsComponentProps extends PopupBuilderCouponDetailsContentSection {
  popup: PopupApiDto<PopupContentTypeV2>;
}

const PopupBuilderCouponDetailsComponent = ({ popup }: PopupBuilderCouponDetailsComponentProps) => {
  return (
    <P margin={0} style={{ width: 'fit-content' }}>
      {formatHtml(t('misc.couponDetails', { code: popup.offer?.code ?? '' }))}
    </P>
  );
};

export type PopupBuilderCouponDetailsComponentVariants = '';

const PopupBuilderCouponDetailsComponentController = (
  props: PropsWithCustomComponent<PopupBuilderCouponDetailsComponentProps>
) => (
  <VariantsController<PopupBuilderCouponDetailsComponentProps, PopupBuilderCouponDetailsComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderCouponDetailsComponent,
      name: 'PopupBuilderCouponDetailsComponent',
    }}
  />
);
export { PopupBuilderCouponDetailsComponentController as PopupBuilderCouponDetailsComponent };
